import { BsCheckCircleFill, BsExclamationCircleFill, BsFillXCircleFill } from 'react-icons/bs';
import { FacilityStatusEnum } from '../../../api';

interface ClearanceBadgeProps {
  status: FacilityStatusEnum;
  className?: string;
  isTransparent?: boolean;
}

export const PresentationBadge = ({ status, className, isTransparent }: ClearanceBadgeProps) => {
  return (
    <>
      {status === FacilityStatusEnum.APPROVED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12 ${
            isTransparent ? 'text-success' : 'bg-primary-muted bg-green-2'
          } ${className ?? ''}`}
        >
          <BsCheckCircleFill className="align-bottom me-1" />
          Facility Approved
        </div>
      )}

      {status === FacilityStatusEnum.DENIED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12
          ${isTransparent ? 'text-danger' : 'bg-red-100'}
          ${className ?? ''}
        `}
        >
          <BsFillXCircleFill className="align-bottom me-1" />
          Facility Declined
        </div>
      )}

      {status === FacilityStatusEnum.PENDING_APPROVAL && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12 ${
            isTransparent ? 'text-neutral-700' : 'bg-neutral-300'
          } ${className ?? ''}`}
        >
          <BsExclamationCircleFill className="align-bottom me-1" />
          Pending Facility Approval
        </div>
      )}
    </>
  );
};
